export default __webpack_public_path__ + "static/media/olivia.2610e57c.jpg";